export function encodeUtf8StringToBase64(value: string): string {
    if (typeof Buffer !== 'undefined') {
        return Buffer.from(value, 'utf8').toString('base64')
    }
    const bytes = new TextEncoder().encode(value)
    let binary = ''
    for (const b of bytes) {
        binary += String.fromCharCode(b)
    }
    return btoa(binary)
}
